
import React from 'react'
import useTableSorting from '../../Hooks/useTableSorting';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loading from '../../Component/Loading';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import PaginationCom from '../../Component/pagination';
import { Modal } from 'react-bootstrap';
import NoRecordFound from '../../Component/NoRecordFound';
import { FaArrowLeft } from 'react-icons/fa6';
import { WEBHOOK_LIST } from '../../Repository/SettingRepo';
import { toast } from 'react-toastify'
import moment from 'moment-timezone';

const Webhook = () => {
    const [webhookList, setWebhookList] = useState([])
    const [paginationTotalCount, setPaginationTotalCount] = useState(0)
    const [loading, setLoading] = useState(false)

    const [openModal, setOpenModal] = useState({
        viewWebhookData: false,
        data: null
    })

    const naviget = useNavigate()
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });

    const webhookHeadCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "data", numeric: true, disablePadding: false, label: "JSON", isShorted: true },
        { id: "date", numeric: false, disablePadding: true, label: "Date", showIcon: true },
        { id: "action", numeric: false, disablePadding: false, showLeft: true, label: "Action", isShorted: false },
    ];
    const { EnhancedTableHead, order, orderBy, stableSort, getComparator, handleRequestSort } = useTableSorting(webhookHeadCells)

    const handleOpenModal = (type, data = null) => {
        setOpenModal((prev) => ({
            ...prev,
            data: data,
            [type]: true,
        }));
    };
    const handleClosedModal = (type) => {
        setOpenModal((pre) => ({
            ...pre,
            data: null,
            [type]: false
        }))
    }

    async function getWebhookList() {
        setLoading(true)
        let payload = {
            page: controller.page,
            count: controller.rowsPerPage
        };
        try {
            let response = await WEBHOOK_LIST(payload)
            setWebhookList(response?.data)
            setPaginationTotalCount(response?.totalCount)
            setLoading(false)
        } catch (error) {
            if (error.message !== "Not Found") toast.error(error.message)
            setWebhookList([])
            setPaginationTotalCount(0)
            setLoading(false)
        }
    }

    useEffect(() => {
        getWebhookList()
        // eslint-disable-next-line
    }, [controller])
    return (
        <>
            {loading && <Loading />}
            <div className="row">
                <div className="col-12 d-flex align-items-center ">
                    <FaArrowLeft className='BACK_ICON' onClick={() => naviget(-1)} />
                    <h3 className='PAGE-NAME'>Webhook</h3>
                </div>
            </div>
            <div className="container-fluid">

                <>
                    <div className="row">
                        {
                            webhookList?.length === 0 && <div className="col-sm-12 mt-3 text-center " >
                                <NoRecordFound />
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <TableContainer className=" mt-4"  >
                                <Table
                                    id="table_mui"
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table">
                                    {
                                        <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={webhookList.length} />
                                    }
                                    <TableBody>
                                        {stableSort(webhookList, getComparator(order, orderBy)).map(
                                            (row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return <React.Fragment key={row?.id}>
                                                    <TableRow id="hover_tr"
                                                        //  }
                                                        style={{ cursor: 'pointer' }}>
                                                        <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                            {controller?.rowsPerPage * (controller?.page - 1) + index + 1}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">
                                                            <pre style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px', maxHeight: '500px' }}>
                                                                {JSON.stringify(JSON.parse(row?.webhookData || "{}"))?.slice(0, 70)}...
                                                            </pre>
                                                        </TableCell>

                                                        <TableCell id={labelId} align="left" >{moment(row?.createdOn).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell id={labelId} align="right" ><i className="fa-solid fa-eye  all_icons_color me-2 fs-6" style={{ cursor: "pointer" }} title='View JSON' onClick={() => handleOpenModal("viewWebhookData", row)}></i></TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                    <section className='w-100 d-flex justify-content-end'>
                        {
                            paginationTotalCount > 10 && <PaginationCom count={paginationTotalCount} controller={controller} setController={setController} />
                        }
                    </section>
                </>

            </div>

            <Modal show={openModal?.viewWebhookData} onHide={() => { handleClosedModal("viewWebhookData") }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Webhook JSON Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px', maxHeight: '500px', overflowY: 'auto' }}>
                        {
                            openModal?.data?.webhookData
                                ? JSON.stringify(JSON.parse(openModal?.data?.webhookData), null, 2)
                                : "No data available"
                        }
                    </pre>
                </Modal.Body>
            </Modal>

        </>
    );
}

export default Webhook
